import { ReactElement, createContext, useContext, useMemo } from 'react';

export enum AppMode {
  DIRECT = 'DIRECT',
  CLOUD = 'CLOUD',
}

export interface AppModeContextValue {
  mode: AppMode;
}

export interface AppModeContextProviderProps {
  mode: AppMode;
  children: ReactElement;
}

const AppModeContext = createContext<AppModeContextValue | undefined>(
  undefined
);

const AppModeProvider = (props: AppModeContextProviderProps) => {
  const { children, mode } = props;

  const contextValue = useMemo<AppModeContextValue>(() => {
    return {
      mode,
    };
  }, [mode]);

  return (
    <AppModeContext.Provider value={contextValue}>
      {children}
    </AppModeContext.Provider>
  );
};

const useAppModeContext = (): AppModeContextValue => {
  return useContext(AppModeContext) as AppModeContextValue;
};

export { AppModeProvider, useAppModeContext };
